import { DefaultConfigProps } from 'types/config'
import Cookies from 'js-cookie'

export const drawerWidth = 260

export const loginRequest = {
  scopes: ['https://graph.microsoft.com/.default', 'openid']
}

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
}

// Función para obtener el company ID de forma reactiva
export const getPlanVitalCompanyID = (): string => {
  const companyId = Cookies.get('company-id') || ''
  return companyId
}

export const appConfig = {
  apiUrl: process.env.REACT_APP_API || '',
  apiUrlExternal: process.env.REACT_APP_API_EXTERNAL || '',
  planVitalClientID: process.env.REACT_APP_PLAN_VITAL_CLIENT_ID || '',
  planVitalCompanyID(): string {
    return getPlanVitalCompanyID()
  }
}

const config: DefaultConfigProps = {
  defaultPath: '/home',
  fontFamily: `'Public Sans', sans-serif`,
  i18n: 'es',
  miniDrawer: false,
  container: false,
  mode: 'light',
  presetColor: 'theme2',
  themeDirection: 'ltr'
}

export const profilesAdministrative: Array<string> = ['Nv.0']
export const viewsProtectedAdministrative: Array<string> = ['users', 'process']

export const gtAuthConfig = {
  appName: process.env.REACT_APP_NAME || 'Plan Vital',
  url: process.env.REACT_GT_AUTH_URL || ''
}

export default config
